import { Button, Paper } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import getAllFiles from '../../api/FileExplorer/getAllFiles.api';
import styles from './FileExplorer.module.scss';
import FileCopyIcon from '@material-ui/icons/FileCopy';

const FileExplorer = () => {
	const [files, setFiles] = useState();
	const [fileName, setFileName] = useState();
	const [link, setLink] = useState();
	const [active, setActive] = useState();

	// useEffect(() => {
	// 	getAllFiles((returned) => setFiles(returned));
	// }, []);

	// const handleClickFile = (e) => {
	// 	var thisFileName = e.currentTarget.dataset.title;
	// 	var thisFileUrl = e.currentTarget.dataset.content;

	// 	setActive(thisFileName);
	// 	setFileName(thisFileName);
	// 	setLink(thisFileUrl);
	// };

	return (
		<div className={styles.file_explorer_page}>
			{/* <p className={styles.title}>Marketing</p>

			<div className={styles.content_wrap}>
				<div className={styles.list_files}>
					{files?.map((file) => {
						return (
							<Paper
								className={`${styles.single_file} ${
									active === file.fileName
										? styles.active
										: ''
								}`}
								data-content={file.href}
								data-title={file.fileName}
								onClick={(e) => handleClickFile(e)}
							>
								<p className={styles.file_name}>
									{file.fileName}
								</p>
							</Paper>
						);
					})}
				</div>
				<div className={styles.view_section}>
					{fileName?.split('.').pop() === 'pdf' && (
						<iframe src={link} className={styles.file_iframe}></iframe>
					)}
					{(fileName?.split('.').pop() === 'jpg' ||
						fileName?.split('.').pop() === 'jpeg') && (
						<div className={styles.file_placeholder}>
							<a href={link} download>
								<img src={link} alt='image' />
							</a>
						</div>
					)}
					{(fileName?.split('.').pop() === 'mp4') && (
						<iframe src={link} className={styles.file_iframe}></iframe>
					)}
					<div className={styles.file_name}>{fileName}</div>
					{active && (
						<Button variant='contained' color='primary'>
							<a href={link || link} alt='link' target='_blank'>
								Download
							</a>
						</Button>
					)}
				</div>
			</div> */}
			<iframe
				src='https://aurora-marketing-only.web.app/'
				frameBorder='0'
				style={{ overflow: 'hidden', height: '100vh', width: '100%' }}
				// style='overflow:hidden;height:100%;width:100%'
				title='Iframe Example'
			></iframe>
		</div>
	);
};

export default FileExplorer;
